module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window-curtain/window-curtain.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window-curtain/window-curtain.png
// module id = 498
// module chunks = 0